import React from 'react'

const IconTrashAdvSearch = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g mask='url(#mask0_18081_4466)'>
        <path
          d='M9.4 16.1535L12 13.5535L14.6 16.1535L15.6538 15.0997L13.0538 12.4997L15.6538 9.89973L14.6 8.84598L12 11.446L9.4 8.84598L8.34625 9.89973L10.9463 12.4997L8.34625 15.0997L9.4 16.1535ZM5.5 20.4997V5.99973H4.5V4.49973H9V3.61523H15V4.49973H19.5V5.99973H18.5V20.4997H5.5ZM7 18.9997H17V5.99973H7V18.9997Z'
          fill='currentColor'
        />
      </g>
    </svg>
  )
}

export default IconTrashAdvSearch
